export const getReviewStyles = (colors, score) => ({
  container: {
    position: 'relative',
    minHeight: '100vh',
    backgroundColor: colors.background,
    color: colors.text,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  groupSelector: {
    position: 'absolute',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1,
    backgroundColor: 'white',
    padding: '8px',
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    minWidth: '200px',
  },
  select: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    backgroundColor: 'white',
  },
  scoreContainer: {
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    backgroundColor: colors.surface,
    padding: '12px 24px',
    borderRadius: '30px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    zIndex: 1000,
    backdropFilter: 'blur(5px)',
    whiteSpace: 'nowrap',
  },
  score: {
    fontSize: '24px',
    fontWeight: '600',
    color: score.total >= 0 ? colors.positiveScore : colors.negativeScore,
    minWidth: '40px',
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  scoreDetailsContainer: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginLeft: '8px',
  },
  scoreDetail: {
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'nowrap',
    color: colors.buttonText,
    fontWeight: '500',
  },
  checkMark: {
    color: colors.positiveScore,
    fontWeight: '700',
    fontSize: '20px',
  },
  wrongMark: {
    color: colors.negativeScore,
    fontWeight: '700',
    fontSize: '20px',
  },
  controlButton: {
    position: 'fixed',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: colors.button,
    color: colors.buttonText,
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    transition: 'transform 0.2s',
    zIndex: 1000,
    bottom: '20px',
    right: '20px',
  }
});
